<div class="container-fluid body">
  <div class="container d-flex justify-content-center align-items-center min-vh-100">
    <div class="card p-4 shadow w-100" style="max-width: 400px;">
      <h3 class="text-center mb-4">Registration</h3>
      <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

        <!-- First Name -->
        <div class="form-floating mb-3">
          <input type="text" id="userName" class="form-control" formControlName="userName" placeholder="User Name">
          <label for="userName">User Name <span class='text-danger'>*</span></label>
          <div *ngIf="f.userName.touched && f.userName.invalid" class="text-danger small">
            User name is required.
          </div>
        </div>

        <!-- Phone -->
        <div class="form-floating mb-3">
          <input type="tel" id="phoneNumber" class="form-control" formControlName="phoneNumber"
            placeholder="Phone Number" [maxlength]="10">
          <label for="phoneNumber">Phone Number <span class='text-danger'>*</span></label>
          <div *ngIf="f.phoneNumber.touched && f.phoneNumber.invalid" class="text-danger small">
            <div *ngIf="f.phoneNumber.errors?.required">Phone number is required.</div>
            <div *ngIf="f.phoneNumber.errors?.pattern">Phone number must be 10 digits.</div>
          </div>
        </div>

        <!-- Email -->
        <div class="form-floating mb-3">
          <input type="email" id="email" class="form-control" formControlName="email" placeholder="Email">
          <label for="email">Email <span class='text-danger'>*</span></label>
          <div *ngIf="f.email.touched && f.email.invalid" class="text-danger small">
            <div *ngIf="f.email.errors?.required">Email is required.</div>
            <div *ngIf="f.email.errors?.email">Enter a valid email.</div>
          </div>
        </div>

        <!-- Password -->
        <!-- Password with toggle -->
        <div class="form-floating mb-3 position-relative">
          <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control"
            formControlName="password" placeholder="Password" />
          <label for="password">Password <span class='text-danger'>*</span></label>

          <!-- Toggle Button -->
          <button type="button"
            class="btn btn-outline-secondary btn-sm position-absolute top-50 end-0 translate-middle-y me-2 border-0"
            (click)="togglePasswordVisibility()" tabindex="-1">
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>

          <div *ngIf="f.password.touched && f.password.invalid" class="text-danger small mt-1">
            <div *ngIf="f.password.errors?.required">Password is required.</div>
            <div *ngIf="f.password.errors?.minlength">Minimum 6 characters required.</div>
          </div>
        </div>


        <!-- Submit Button -->
        <button type="submit" class="btn btn-primary w-100">Register</button>
        <div class="text-center mt-3">
          <p class="mt-3 mb-0 text-bold text-center">Already have an account?
            <a routerLink="/login" class="text-decoration-none">Sign in</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
<footer class="footer text-center text-black poppins-medium mt-4 fixed-bottom">
  <p class="text-center">Copyright © 2025.
    Designed & developed by <a href="https://cktechsoln.in/" target="_blank" class="poppins-extrabold">CKTech Solution</a>
  </p>
</footer>